import { ReactNode } from 'react';

import styled from '@emotion/styled';

import { AlertIcon, CheckIcon, InfoIcon } from '../icons';

interface Props {
  children?: ReactNode;
  className?: string;
  title?: string;
  type: AlertType;
  showIcon?: boolean;
  bgColor?: string;
}

type AlertType = 'success' | 'error' | 'info' | 'warning';

// TODO: Move to common library and implement as a generic component, not a spaghetti like below
export const Alert = ({ children, className, title, type, showIcon = true, bgColor }: Props) => (
  <StyledAlert className={className} title={title} type={type} bgColor={bgColor}>
    <div>
      {showIcon && (
        <StyledIcon>
          {type === 'success' && <img src={CheckIcon} alt="" />}
          {type === 'error' && <img src={AlertIcon} alt="" />}
          {type === 'info' && <img src={InfoIcon} alt="" />}
          {type === 'warning' && <img src={AlertIcon} alt="" />}
        </StyledIcon>
      )}
    </div>
    <Content>
      {title && <StyledTitle>{title}</StyledTitle>}
      <Description>{children}</Description>
    </Content>
  </StyledAlert>
);

const StyledAlert = styled.div<Pick<Props, 'type' | 'bgColor'>>`
  border-radius: 12px;
  display: flex;
  justify-content: flex-start;
  gap: 24px;
  padding: 40px;
  width: 100%;

  background-color: ${(props) => props.bgColor || getBackgroundColor(props.type)};
`;

const StyledTitle = styled.span`
  align-items: center;
  color: rgba(35, 8, 90, 1);
  display: inline-flex;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 12px;
`;

const Content = styled.div`
  flex-grow: 1;
`;

const Description = styled.div`
  font-size: 18px;
  line-height: 27px;
`;

const StyledIcon = styled.div`
  color: rgba(35, 8, 90, 1);
`;

function getBackgroundColor(type: AlertType): string {
  switch (type) {
    case 'info':
      return 'rgba(151, 218, 255, 0.6)';
    case 'warning':
      return 'rgba(255, 228, 158, 0.4)';
    case 'error':
      return 'rgba(255, 186, 184, 0.4)';
    case 'success':
      return 'rgba(0, 149, 59, 0.2)';
  }
}
